module.exports = __webpack_public_path__ + "bt.f5f34922.svg";